module.exports = "/images/55ba2dc089985db19ffbe7f61aec464e.jpg";